export default "__VITE_ASSET__BaBP82FM__"